import React from 'react';
import { render } from 'react-dom';
import LicensePlateModal from "./components/LicensePlateModal";

const werkplaatsPlannerModalFlowNodes = document.querySelectorAll('.toggle-werkplaatsplanner-modal');

werkplaatsPlannerModalFlowNodes.forEach((node) => {
    const proceeding = node.getAttribute('data-proceeding');
    const vehicles = JSON.parse(node.getAttribute('data-vehicles'));
    const userName = node.getAttribute('data-username');
    const licensePlateParam = node.getAttribute('data-licenseplate-param');
    const mileageParam = node.getAttribute('data-mileage-param');

    node.addEventListener('click', () => {
        if (!vehicles || vehicles.length === 0) {
            window.open(proceeding, '_blank');
        } else {
            render(
                <LicensePlateModal
                    proceeding={proceeding}
                    licensePlateParam={licensePlateParam}
                    mileageParam={mileageParam}
                    vehicles={vehicles}
                    userName={userName}
                    onClose={() => {
                        render(null, document.getElementById('werkplaatsplanner-modal'));
                    }}
                />,
                document.getElementById('werkplaatsplanner-modal')
            );
        }
    });
});

